import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalCloseButton,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';
import { useArchiveAllTicketModal } from './use-all-archive-ticket-modal';

export type TArchiveAllTicketModalType = 'ArchiveAllTicketModal';
export interface IArchiveAllTicketModalProps {
  spaceId: string;
  spaceColumnId: string;
  onSuccess?: () => Promise<void> | void;
}

const ArchiveAllTicketModal = memo(({ spaceId, spaceColumnId, onSuccess }: IArchiveAllTicketModalProps) => {
  const {
    // FORM
    form,
    isOpen,
    isDisabledForm,
    isLoadingForm,

    // HANDLERS
    handleCancelModal,
    handleCloseModal,
    handleSubmitForm,
  } = useArchiveAllTicketModal({
    spaceId,
    spaceColumnId,
    onSuccess,
  });

  // RENDER
  return (
    <Modal
      isOpen={isOpen}
      lockBodyScroll
      onClose={handleCloseModal}
      isCloseOutside={false}
      className="md:w-[500px] w-[345px] p-[24px]"
    >
      <ModalHeader>
        <ModalTitle>Are you sure you want to archive all tickets in this column?</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="archive-all-ticketing-ticket-form"
          className="grid gap-[16px] mt-[16px]"
        >
          <span className="text-[14px] font-normal text-[#9D9D9C]">
            All tickets in this column will be moved to the archive and removed from your active list. You can restore
            them anytime.
          </span>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleCancelModal();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="archive-all-ticketing-ticket-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner className="w-[18px] h-[18px]" /> : null} Archive All
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
ArchiveAllTicketModal.displayName = 'ArchiveAllTicketModal';
export default ArchiveAllTicketModal;
